import React, {useEffect, useState} from 'react';
import Image from 'next/image';
import {PLACEHOLDER_IMAGE_URL} from "@/constants/general-constants";

const ImageWithFallback = ({src, fallbackSrc = PLACEHOLDER_IMAGE_URL, ...otherProps}) => {
    const [imgSrc, setImgSrc] = useState(src || "");
    const [onError, setOnError] = useState(false);

    useEffect(() => {
        if(src) {
            setImgSrc(src)
        }
    }, [src]);

    // "" + null => typeof null === "string
    if(!src || src === "null") {
        return null
    }

    return (
        <Image
            {...otherProps}
            alt={otherProps.alt || "placeholder"}
            src={imgSrc}
            onError={onError ? null : () => {
                setImgSrc(fallbackSrc);
                setOnError(true)
            }}
        />
    );
};

export default ImageWithFallback;
